import { Route, Routes } from 'react-router-dom'
import CallsList from './CallsList'

export const CallsRoute = () => (
 <Routes>
  <Route path="" element={<CallsList />} />
 </Routes>
)
